/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface PatchedFileBoundaryCondition
 */
export interface PatchedFileBoundaryCondition {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  readonly file?: any;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
}

/**
 * Check if a given object implements the PatchedFileBoundaryCondition interface.
 */
export function instanceOfPatchedFileBoundaryCondition(
  value: object
): value is PatchedFileBoundaryCondition {
  return true;
}

export function PatchedFileBoundaryConditionFromJSON(json: any): PatchedFileBoundaryCondition {
  return PatchedFileBoundaryConditionFromJSONTyped(json, false);
}

export function PatchedFileBoundaryConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedFileBoundaryCondition {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    file: json["file"] == null ? undefined : json["file"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
  };
}

export function PatchedFileBoundaryConditionToJSON(json: any): PatchedFileBoundaryCondition {
  return PatchedFileBoundaryConditionToJSONTyped(json, false);
}

export function PatchedFileBoundaryConditionToJSONTyped(
  value?: Omit<
    PatchedFileBoundaryCondition,
    "url" | "id" | "uid" | "simulation" | "file" | "state" | "stateDetail"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
